export const CONFIG = {
  amplifyADFS: {
    Auth: {
      // REQUIRED - Amazon Cognito Region
      region: 'eu-west-1',

      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: 'eu-west-1_NcZcEeZT1',

      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: 'na6e6itgut1fndv3onf1ar3og',

      // OPTIONAL - Hosted UI configuration
      oauth: {
        domain: 'europe-adfs.auth.eu-west-1.amazoncognito.com',
        scope: ['email', 'openid'],
        redirectSignIn: 'https://upload.vallourec.com/upload',
        redirectSignOut: 'https://upload.vallourec.com',
        responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
      }
    }
  },
  amplifyExternal: {
    Auth: {
      // REQUIRED - Amazon Cognito Region
      region: 'eu-west-1',

      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: 'eu-west-1_6NZuqf3De',

      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: '784ph772ribspenfm25s92aap4',
    }
  }
  ,api: {
    invokeUrl: 'https://upload-api.app.vallourec.com'
  },
  website: {
    url: 'https://upload.vallourec.com'
  },
  stage: 'prod',
  cognitoTranslateGroup: 'val-prod-vallourec-upload-translate',
};
